import React from 'react';
import ReactDOM from 'react-dom';

import {View} from '../common/utils/types';

import RewardShop from './components/RewardShop';
import Shutdown from './components/shutdown/Shutdown';
import {Domain, Stage} from "@zooplus/commons-lang";

const component = document.getElementById('bonus-points-reward-shop-wrapper');

if (component) {
  const siteDomain = component.getAttribute('data-site-domain') as Domain;
  const customerId = Number(component.getAttribute('data-customer-id'));
  const view = component.getAttribute('data-view')! as View;
  const environment = component.getAttribute('data-environment') as Stage;
  const bpEnabled = JSON.parse(component.getAttribute('data-enabled')!);

  bpEnabled &&
    ReactDOM.render(
      <RewardShop
        siteDomain={siteDomain}
        customerId={customerId}
        view={view}
        environment={environment}
        bpEnabled={bpEnabled}
      />,
      component,
    );

  !bpEnabled &&
    ReactDOM.render(
      <Shutdown
        siteDomain={siteDomain}
        bpEnabled={bpEnabled}
      />,
      component,
    );
}
